import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title,
} from "chart.js";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import '../chart/chart.css';
import { useMemo, useRef, useEffect } from "react";

// Registra os componentes do Chart.js
ChartJS.register(ArcElement, Tooltip, Legend, Title, ChartDataLabels);

type ChartProps = {
  used: number;
  limit: number;
};

export const Chart = ({ used, limit }: ChartProps) => {
  const validUsed = Math.max(0, used);
  const validLimit = Math.max(1, limit);
  const remaining = Math.max(0, validLimit - validUsed);

  const data = useMemo(() => ({
    labels: ["", ""],
    datasets: [
      {
        data: [validUsed, remaining],
        backgroundColor: ['#00b6db', '#002c6b'],
        label: 'Consultas',  // Adicione um título à legenda

      },
    ],
  }), [validUsed, remaining]);



  const CenterText = {
    id: 'centerText',
    afterDatasetUpdate(chart: any) {
      chart.draw(); // força redesenho no update dos dados
    },
    afterDraw(chart: any) {
      const { ctx, chartArea } = chart;
      const { width, height, top, left } = chartArea;
      const centerX = (left + width) / 2;
      const centerY = (top + height) / 2 + 30;
      const percentage = chart.data.datasets?.[0]?.data?.[0] ?? 0;
      const limit = chart.data.datasets?.[0]?.data?.reduce((a: number, b: number) => a + b, 0) || 1;
      const value = limit > 0 ? `${Math.round((percentage / limit) * 100)}%` : "0%";

      ctx.save();
      ctx.font = '25px Arial';
      ctx.fillStyle = '#00b6de';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(value, centerX, centerY);
      ctx.restore();
    }
  };

  const options = useMemo(() => ({
    cutout: '85%',
    rotation: -90,
    circumference: 180,
    plugins: {
      legend: { display: false, },
      tooltip: { enabled: false },
      datalabels: {
        display: false,
        color: '#00b6de',
      },
    },
  }), []);

  return (
    <div className="customflex">
      <div className="flex gap-10 justify-center customHeight">
        <div className="customChartWidth">
        <div className="chart-label">
          </div>
          <Doughnut
            className="doughnutChartContainer gs1-color-sky"
            data={data}
            options={options}
            plugins={[CenterText]}
          />
     
        </div>
      </div>
    </div>
  );
};

export default Chart;
